import { Card, Row, Col } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";

export default function Profile() {
  const { user } = useAuth();

  if (!user) return <p className="text-center mt-5">Loading...</p>;

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    toast.success('copied!')
  };

  return (
    <Card className="">
      <Card.Body>
        <div className="d-flex align-items-center mb-4">
          <i className="bi bi-person-circle text-primary me-3" style={{fontSize:'35px'}}></i>

          <div>
            <h5 className="mb-0">
              {user.first_name} {user.last_name}
            </h5>
            <small className="text-muted">{user.role.toUpperCase()}</small>
          </div>
        </div>

        <Row>
          <Col md={6} className="mb-3">
            <strong>Email:</strong>
            <div className="d-flex align-items-center">
              <span className="me-2">{user.email}</span>

              <i
                className="bi bi-clipboard text-secondary cursor-pointer"
                onClick={() => handleCopy(user.email)}
                style={{cursor:'pointer'}}
              ></i>
            </div>
          </Col>

          <Col md={6} className="mb-3">
            <strong>Phone:</strong>
            <div className="d-flex align-items-center">
              <span className="me-2">{user.phone}</span>

              <i
                className="bi bi-clipboard text-secondary cursor-pointer"
                onClick={() => handleCopy(user.email)}
                style={{cursor:'pointer'}}
              ></i>
            </div>
          </Col>

          <Col md={6} className="mb-3">
            <strong>Country:</strong>
            <div>{user.country}</div>
          </Col>

          <Col md={6} className="mb-3">
            <strong>City:</strong>
            <div>{user.city || "—"}</div>
          </Col>

          <Col md={12} className="mb-3">
            <strong>Address:</strong>
            <div>{user.address || "—"}</div>
          </Col>

          <Col md={6} className="mb-3">
            <strong>Referral Code:</strong>
            <div className="d-flex align-items-center">
              <span className="me-2">{user.referral_code || "—"}</span>
              {user.referral_code && (
                <i
                  className="bi bi-clipboard text-secondary cursor-pointer"
                  onClick={() => handleCopy(user.email)}
                  style={{cursor:'pointer'}}
                ></i>
              )}
            </div>
          </Col>

          <Col md={6} className="mb-3">
            <strong>Referred By:</strong>
            <div>{user.reference_by_code || "—"}</div>
          </Col>

          <Col md={6} className="mb-3">
            <strong>Status:</strong>
            <span
              className={`badge ms-2 ${
                user.status === "active" ? "bg-success" : "bg-secondary"
              }`}
            >
              {user.status}
            </span>
          </Col>

          <Col md={6} className="mb-3">
            <strong>Payment:</strong>
            <span
              className={`badge ms-2 ${
                user.payment_status === "paid"
                  ? "bg-success"
                  : user.payment_status === "processing"
                  ? "bg-warning"
                  : "bg-danger"
              }`}
            >
              {user.payment_status}
            </span>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
